import { Spinner } from 'react-bootstrap';

const SkillsMatrixDisplayField = ({ label, value, loading }) => {
  return (
    <div>
      <div className="input-label pb-1">{label}</div>
      <div className="matrix-field">{loading ? <Spinner animation="border" size="sm" /> : value}</div>
    </div>
  );
};

export default SkillsMatrixDisplayField;
